import { config } from "config";

export const environment = {
  production: true,
  apiURL: config.prodApiUrl,
  syncFusionLicense: config.syncFusionLicense,
  company: 'plateline',
  iconLogo: 'assets/images/logo/logo_big.png',
  coverLogo: 'assets/images/logo/logo_cover.svg',
  theme: 'theme-default',
};
